import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show_series } from '../models/horse_show_series';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class HorseShowSeriesService {

  constructor(private http: HttpClient) {
  }

  get(id: string): Promise<Horse_show_series> {
  	 return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'horse_show_series/get_horse_show_series/id/' + id).subscribe((response:any) => {
			if(response.type == 'horse_show_series' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  getListForCredentialingUser(): Promise<Horse_show_series[]> {
  	return this.getListWithRest('get_where_user_can_credential');
  }

  private getListWithRest(rest_url: string) : Promise<Horse_show_series[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'horse_show_series/' + rest_url).subscribe((response:any) => {
			if(response.type == 'horse_show_series_list' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }


}
